import { render, staticRenderFns } from "./CSidenavFrame.vue?vue&type=template&id=5ae36416&"
import script from "./CSidenavFrame.vue?vue&type=script&lang=ts&"
export * from "./CSidenavFrame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports